import { AlertCircle, File, FileText, Loader2, X } from "lucide-react";

interface UploadedFileCardProps {
  file: File;
  onRemove: () => void;
  disabled?: boolean;
  isUploading?: boolean;
  uploadError?: string | null;
}

export function UploadedFileCard({
  file,
  onRemove,
  disabled = false,
  isUploading = false,
  uploadError = null,
}: UploadedFileCardProps) {
  const getFileExtension = (fileName: string): string => {
    const parts = fileName.split(".");
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
  };

  const fileExtension = getFileExtension(file.name);
  const statusColor =
    fileExtension === "pdf"
      ? "bg-red-500"
      : fileExtension === "doc" || fileExtension === "docx"
      ? "bg-blue-500"
      : "bg-blue-500";

  return (
    <div className="max-w-2xs relative">
      <div className="relative rounded-md border border-base-300 bg-base-200">
        <div className="flex cursor-pointer items-center gap-2 py-1.5 ps-2 pe-4">
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-md px-2 leading-6 font-semibold text-white ${statusColor}`}
          >
            {isUploading ? (
              <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
            ) : uploadError ? (
              <AlertCircle className="h-5 w-5" aria-hidden="true" />
            ) : (
              <FileIcon fileExtension={fileExtension} />
            )}
          </div>
          <div className="flex flex-col justify-center min-w-0 flex-1">
            <div className="text-sm font-medium">
              <p className="group/text-truncator relative grid">
                <span className="block truncate">{file.name}</span>
              </p>
            </div>
            <div className="text-base-content/70 text-xs capitalize">
              {uploadError ? "Erreur" : isUploading ? "Chargement..." : fileExtension || "fichier"}
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className="btn btn-secondary btn-xs btn-circle absolute -end-3 -top-3 z-10 border-2 border-white shadow-sm aria-disabled:bg-base-300 aria-disabled:text-base-content/50 aria-disabled:cursor-not-allowed"
          aria-label="Supprimer le fichier"
        >
          <X className="size-3" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

function FileIcon({ fileExtension }: { fileExtension: string }) {
  // FileText for doc and docx
  if (fileExtension === "doc" || fileExtension === "docx") {
    return <FileText className="h-5 w-5" aria-hidden="true" />;
  }
  if (fileExtension === "pdf") {
    return <File className="h-5 w-5" aria-hidden="true" />;
  }
  return <File className="h-5 w-5" aria-hidden="true" />;
}
